import type {LucideIcon} from "lucide-react";
import {Car, Home, Building2, ParkingCircle, Scale, UserRound, Users, Waves} from "lucide-react";

export type ResidentHomeRoadmapPillar = {
  id: string;
  title: string;
  icon: LucideIcon;
  iconWrapperClassName: string;
  iconClassName: string;
};

export const RESIDENT_HOME_CITATIONS_ICON = {
  icon: Scale,
  iconWrapperClassName: "bg-muted",
  iconClassName: "text-foreground",
} as const;

export const RESIDENT_HOME_PERMANENT_PERMITS_ICON = {
  icon: ParkingCircle,
  iconWrapperClassName: "bg-primary/10",
  iconClassName: "text-primary",
} as const;

export const RESIDENT_HOME_AMENITIES_ICON = {
  icon: Waves,
  iconWrapperClassName: "bg-muted",
  iconClassName: "text-primary",
} as const;

/** @deprecated Roadmap pillars removed — live widgets use dedicated icon constants above. */
export const RESIDENT_HOME_ROADMAP_PILLARS: ResidentHomeRoadmapPillar[] = [];

/** Icon config for the landlord current-tenant card. */
export const RESIDENT_HOME_TENANT_ICON = {
  icon: Users,
  iconWrapperClassName: "bg-muted",
  iconClassName: "text-primary",
} as const;

/** Icon config for the tenant-facing landlord card. */
export const RESIDENT_HOME_LANDLORD_ICON = {
  icon: UserRound,
  iconWrapperClassName: "bg-muted",
  iconClassName: "text-primary",
} as const;

/** Icon config for the resident home welcome / property block. */
export const RESIDENT_HOME_PROPERTY_ICON = {
  icon: Building2,
  iconWrapperClassName: "bg-primary/10",
  iconClassName: "text-primary",
} as const;

/** @deprecated Preview-only icon config — household/safelistings cards are live widgets. */
export const RESIDENT_HOME_HOUSEHOLD_ICON = {
  icon: Home,
  iconWrapperClassName: "bg-primary/10",
  iconClassName: "text-primary",
} as const;

/** @deprecated Preview-only icon config — household/safelistings cards are live widgets. */
export const RESIDENT_HOME_SAFELISTINGS_ICON = {
  icon: Car,
  iconWrapperClassName: "bg-muted",
  iconClassName: "text-primary",
} as const;
